import { render } from "./DatabaseConnections.vue?vue&type=template&id=e74b98b2&scoped=true"
import script from "./DatabaseConnections.vue?vue&type=script&lang=js"
export * from "./DatabaseConnections.vue?vue&type=script&lang=js"

import "./DatabaseConnections.vue?vue&type=style&index=0&id=e74b98b2&scoped=true&lang=css"
import "./DatabaseConnections.vue?vue&type=style&index=1&id=e74b98b2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e74b98b2"]])

export default __exports__